import { connect } from "react-redux";
import moment from "moment-timezone";
import React, { Component } from "react";

import { providerRequests } from "@/api/(requests)/provider";
import { sharedRequests } from "@/api/(requests)/shared";

import Button from "../../../components/UI/Button";
import CardHeading from "../../../components/UI/Headings/CardHeading";
import {
  CommentBox,
  DownloadBtn,
  HeaderAttribute,
  HeaderTitle,
  SquashedValues,
} from "../../../components/Common/ReportsView";
import { getQueryParams, toTitleCase } from "../../../utils/filters";
import images from "../../../utils/images";
import { setDynamicRouteConfiguration } from "../../../redux/actions/navbar";
import { severityData } from "../../../components/Provider/Reports/Constants";

import Ratings from "./PatientProfileView/Ratings";

import "./Styles.scss";
import "../../../components/UI/BackLink/styles.scss";

class IPSRReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commentError: null,
      patientId: this.props.match.params.patientId,
      ReportComment: null,
      reportData: null,
      showCommentBox: false,
    };
  }
  componentDidMount() {
    const dynamicRouteConfig = {};

    dynamicRouteConfig["menuSection"] = {
      icon: "./icons/back-arrow.svg",
      link: "/app/reports",
    };
    dynamicRouteConfig["logoSection"] = { title: "Report Details" };

    this.props.setDynamicRouteConfiguration(dynamicRouteConfig);
    this.fetchIpsrReport();
  }

  componentWillUnmount() {
    this.props.setDynamicRouteConfiguration({});
    // document.removeEventListener('click', this.onDocumentClick)
  }

  toggleCommentBox = () => {
    this.setState((ps) => {
      return {
        commentError: null,
        ReportComment: null,
        showCommentBox: !ps.showCommentBox,
      };
    });
  };
  submitComment = (e) => {
    e.preventDefault();
    let urlParams = { patientId: this.state.patientId };
    let data = {
      comment: this.state.ReportComment,
      report_type: "IPSR",
    };

    providerRequests.set_provider_comment({ data, urlParams }).catch((err) => {
      console.log(err);
    });
    this.toggleCommentBox();
  };

  handleCommentChange = (e) => {
    const value = e.target.value;

    this.setState(
      {
        ReportComment: value,
      },
      this.validateComment,
    );
  };

  handleCommentBlur = () => {
    this.validateComment();
  };

  validateComment = () => {
    let value = this.state.ReportComment;

    if (!value || !value.trim()) {
      this.setState({
        commentError: "Comment is required",
      });

      return;
    }
    this.setState({
      commentError: null,
    });
  };

  fetchIpsrReport = async () => {
    let urlParams = { patientId: this.state.patientId };
    let searchParams = { type: "ipsr" };
    let reports = await sharedRequests.fetch_report({ searchParams, urlParams });

    this.saveFetchedReportInState(reports);
  };
  saveFetchedReportInState = (reportData) => {
    this.setState({ reportData });
  };

  HeaderCommentBox = () => {
    return (
      <CommentBox
        cancel={this.toggleCommentBox}
        error={this.state.commentError}
        onInputBlur={this.handleCommentBlur}
        onInputChange={this.handleCommentChange}
        onInputFocus={this.handleCommentFocus}
        placeholder="Please enter your comment"
        submit={this.submitComment}
        value={this.state.ReportComment}
      />
    );
  };

  HeaderContent = () => {
    const {
      clinician_name,
      dob,
      first_name,
      last_name,
      modified_at,
      patient_id,
      report_url,
      type,
    } = this.state.reportData;
    const patientFullName = toTitleCase(first_name + " " + last_name);
    /** -----------
     * date of format `YYYY/MM/DD HH:mm:ss`
     * is split into ['YYYY/MM/DD','HH:mm:ss']
     */
    const splittedDate = modified_at.split(" ");
    /** --------- */
    const LocaleModified_time = moment.utc(splittedDate[1], "HH:mm").local().format("hh:mm a");

    return (
      <div className="row no-gutters pb-3" style={{ "border-bottom": "1px solid #B8B8B8" }}>
        {/* patient name */}
        <div className="col-12 mb-2">
          <HeaderTitle text={patientFullName} />
        </div>
        {/* report type */}
        <div className="col-12 mb-2">
          <HeaderAttribute
            attribute="Report Type"
            value={<SquashedValues valueList={[type, splittedDate[0], LocaleModified_time]} />}
          />
        </div>
        {/* Clinician Name */}
        <div className="col-12 mb-2">
          <HeaderAttribute attribute="Clinician Name" value={clinician_name} />
        </div>
        {/* DOB */}
        <div className="col-12 col-lg-6 mb-2 mb-lg-0">
          <HeaderAttribute attribute="Date of Birth" value={dob} />
        </div>
        {/* header controls/actions */}
        <div className="IBARReport__HeaderControls col-12 col-lg-6 d-flex justify-content-lg-end">
          <div className="mr-2 mr-lg-3">
            <DownloadBtn url={report_url} />
          </div>
          <Button
            className="Btn fs-14 Btn--pri tw:font-light"
            onClick={this.toggleCommentBox}
            style={{ "min-height": "35px", padding: "4px 20px" }}
          >
            Add Provider Comment
          </Button>
        </div>
      </div>
    );
  };

  renderRatings = () => {
    return (
      <div className="row no-gutters mt-4">
        {severityData.map((level, index) => {
          return (
            <div className="Reports__widget-wpr col-6 col-lg" key={level.caption || index}>
              <label className="Reports__label m-0">
                <span className="Reports__mask" />
                <span className="Reports__value">{level.value}</span>
                <span className="SCQBox__caption fs-12 fs-lg-14">{level.caption}</span>
              </label>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    let backLinkText = "Back To Reports";

    if (getQueryParams("patient-id", this.props.location.search)) {
      backLinkText = "Back To Patient Profile";
    }

    let content = (
      <div className="IPSRReport container py-5">
        <div className="d-none d-lg-block mb-4">
          <div className="BackLink cursor" onClick={() => this.props.history.goBack()}>
            <img alt="back btn" src={images("./icons/solidBckBtn.svg")} />
            <span>{backLinkText}</span>
          </div>
        </div>
        <header className="IPSRReport__Header">
          <this.HeaderContent />
        </header>
        {this.state.showCommentBox && (
          <section className="mt-3">
            <this.HeaderCommentBox />
          </section>
        )}
        <div className="Reports-card my-4 mx-auto">
          <ol className="mx-md-2 p-0 px-md-4 pt-md-4 pb-md-5 mb-0">
            {this.state.reportData && renderIPSRQuestions(this.state.reportData.report_data)}
          </ol>
        </div>
        <Ratings
          {...this.props}
          excludeBackLink={true}
          excludeName={true}
          isNestedComponent={true}
        />
      </div>
    );

    return this.state.reportData && content;
  }
}

export default connect(null, {
  setDynamicRouteConfiguration,
})(IPSRReport);

const renderIPSRQuestions = (report_data) => {
  return report_data.sections.map((reportTitle, index) => {
    return reportTitle.type === "list" ? (
      <li className="mt-lg-5 mt-1" key={reportTitle.title || index}>
        <CardHeading className="fs-18 d-inline-block" text={toTitleCase(reportTitle.title)} />
        <ul className="row IPSR__list-wpr">
          {reportTitle.context.map((content, idx) => {
            return (
              <li className="col-12 col-lg-6 IPSR__list-content pl-4 pl-lg-5" key={idx}>
                {content}
              </li>
            );
          })}
        </ul>
      </li>
    ) : (
      <li className="mt-lg-5 mt-1" key={reportTitle.title || index}>
        <CardHeading className="fs-18 d-inline-block" text={reportTitle.title} />
        <p className="IPSR__list-content">{reportTitle.content}</p>
      </li>
    );
  });
};
